import Model, { JsonObject } from 'src/models/model'
import ReportChart from 'src/models/report/ReportChart'
import ReportTableColumn from 'src/models/report/ReportTableColumn'

export default class Widget extends Model {
  static name = 'Widget'

  static define () {
    this.fields = {
      type: {
        type: String,
        output: true
      },
      columns: {
        type: [ReportTableColumn]
      },
      outputType: {
        type: String,
        output: true
      },
      title: {
        type: String,
        output: true
      },
      subtitle: {
        type: String,
        output: true
      },
      values: {
        type: JsonObject,
        output: true
      },
      sparkline: {
        type: ReportChart,
        output: true
      }
    }
  }
}
